module.exports = __webpack_public_path__ + "img/9cf59a943cfa4ccc940d6ec935fed713-1024.1371771e.jpg";